import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Routing from "./router/index"
import '../src/assets/css/icofont.min.css';
import'../src/assets/css/owl.carousel.min.css';
import'../src/assets/css/bootstrap.min.css';
import'../src/assets/css/aos.css';
import'../src/assets/css/style.css';
import '../src/assets/css/responsive.css';



import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routing/>
      </Router>
    </HelmetProvider>
  );
}

export default App;
